import { Entity, Field } from "@the-real-insight/tri-model";

interface Properties {
    entity: Entity;
    hiddenFields?: string[];
    valueWidth?: string;
}

export const EntityFields = (properties: Properties) => {
    console.log(properties.entity);

    return <table className="width100">
        <tbody>
            {properties.entity.getTypeClass().fields.filter((field: Field) => field.type !== JSON && field.name !== '_id' && field.name !== '_tenant' && !properties.hiddenFields?.includes(field.name)).map((field: Field) => {
                return <tr key={field.name}>
                    <td className="fontWeightBold width200">{field.getLabel('de')}:</td>
                    <td style={{minWidth: properties.valueWidth || '300px'}}>
                        {(() => {
                            if (field.type === Date) {
                                return (new Date((properties.entity as any)[field.name])).toLocaleDateString();
                            } else {
                                return (properties.entity as any)[field.name];
                            }
                        })()}
                    </td>
                </tr>;
            })}
        </tbody>
    </table>;
}